import { useQuery } from "react-query";

import { staticDropdownValuesService } from "services";

const useMonthsQuery = () =>
	useQuery("months", staticDropdownValuesService.getMonths);

export default useMonthsQuery;

export const useMonthsQueryForHookForm = () =>
	useQuery("months", staticDropdownValuesService.getMonthsForHookForm);
